import React from 'react';
import { Scenario, Scene, SceneElement } from '../../types';
import { ContentItemForm } from './content-forms';
import { JsonEditor } from './JsonEditor';
import { getContentItemIcon, getContentItemLabel, getContentItemSummary } from './utils';
import styles from './scenario-studio.module.css';

interface ContentEditorProps {
  scenarioId: string;
  scenario: Scenario;
  scene: Scene;
  onScenePatch: (patch: Partial<Scene>) => void;
}

/**
 * Éditeur du bloc scène (format v2 : 1 scène = 1 bloc typé).
 */
export const ContentEditor: React.FC<ContentEditorProps> = ({ scenarioId, scenario, scene, onScenePatch }) => {
  const sceneIds = scenario.scenes.map((s) => s.id);
  const characters = scenario.metadata.characters ?? [];
  const summary = getContentItemSummary(scene);

  return (
    <div className={styles.contentEditor}>
      <div className={styles.panelHeader}>
        <h3>
          <span aria-hidden>{getContentItemIcon(scene)}</span> {getContentItemLabel(scene)}
        </h3>
        {summary && <span className={styles.listItemSummary}>{summary}</span>}
      </div>

      <div className={styles.card}>
        <ContentItemForm
          item={scene}
          scenarioId={scenarioId}
          sceneBackground={scene.background}
          sceneIds={sceneIds}
          characters={characters}
          onChange={(item: Scene, elements?: SceneElement[]) =>
            onScenePatch({ ...item, ...(elements !== undefined ? { elements } : {}) })
          }
          sceneElements={scene.elements}
        />
        <JsonEditor
          label="bloc complet"
          value={scene}
          onChange={(item: Scene) => onScenePatch(item)}
        />
      </div>
    </div>
  );
};
